import getParameterFromURL from '../utils/scripts/getParameterFromURL';

const initialState = {
	currentStep: null,
	previousStep: 'age',
	nextStep: null,
	currentStepIndex: null,
	totalSteps: null,
	currentStepCompleted: null,
	showActionBar: null,
	showStatusBar: null,
	beforeAfterB: getParameterFromURL('beforeAfterB') === 'true',
	beforeAfterC: getParameterFromURL('beforeAfterC') === 'true',
	xmasStartScreen: getParameterFromURL('xmasStartScreen') === 'true',
	bigPhotoStartScreen: getParameterFromURL('bigPhotoStartScreen') === 'true',
	ageGroupStartScreen: getParameterFromURL('ageGroupStartScreen') === 'true',
	coloredOptionsStartScreen: getParameterFromURL('coloredOptionsStartScreen') === 'true',
	zonesStartScreen: getParameterFromURL('zonesStartScreen') === 'true',
	newYearStartScreen: getParameterFromURL('newYearStartScreen') === 'true',
	config: getParameterFromURL('config') || 'defaultConfig'
};

function steps (state = initialState, action) {
	switch (action.type) {
	case 'SET_STEPS':
		return {
			...state,
			list: action.payload
		};

	case 'STEP_GO_TO':
		return {
			...state,
			currentStep: action.payload
		};

	case 'SET_TOTAL_STEPS':
		return {
			...state,
			totalSteps: action.payload
		};

	case 'SET_CURRENT_INDEX':
		return {
			...state,
			currentStepIndex: action.payload
		};

	case 'SET_STEP_STATUS':
		return {
			...state,
			list: action.payload
		};

	case 'SET_PREVIOUS_STEP':
		return {
			...state,
			previousStep: action.payload
		};

	case 'SET_NEXT_STEP':
		return {
			...state,
			nextStep: action.payload
		};

	case 'SET_CURRENT_STEP_COMPLETED_STATUS':
		return {
			...state,
			currentStepCompleted: action.payload
		};

	case 'CHECK_ACTION_BAR_SHOWING':
		return {
			...state,
			showActionBar: action.payload
		};

	case 'CHECK_STATUS_BAR_SHOWING':
		return {
			...state,
			showStatusBar: action.payload
		};

	case 'SET_CURRENT_CONFIG':
		return {
			...state,
			currentConfig: action.payload
		};

	default:
		return state;
	}
}

export default steps;
